import { createFileRoute, redirect } from '@tanstack/react-router'
import { sessionQuery } from '@/shell/session'

/** "/" → the last (or first) workspace's overview. */
export const Route = createFileRoute('/_app/')({
  beforeLoad: async ({ context }) => {
    const s = await context.queryClient.ensureQueryData(sessionQuery)
    let last: string | null = null
    try {
      last = localStorage.getItem('esm-last-workspace')
    } catch {
      last = null
    }
    const ws = s.workspaces.find(w => w.id === last) ?? s.workspaces[0]
    if (ws) throw redirect({ to: '/w/$ws/overview', params: { ws: ws.id } })
    throw redirect({ to: '/org/workspaces' })
  },
})
